export { default as Pictogram } from './Pictogram'
